// extracted by mini-css-extract-plugin
export default {"base":"BaseTorneos_base__pGp+j"};